var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-segmented" },
    _vm._l(_vm.innerLabels, function(label) {
      return _c(
        "div",
        {
          key: label.value,
          staticClass: "ui-segmented__tab",
          class: _vm.getLabelClass(label),
          on: {
            click: function($event) {
              return _vm.$emit("input", label.value)
            }
          }
        },
        [
          label.icon
            ? _c("f-sprite-icon", {
                staticClass: "ui-segmented__icon",
                attrs: { "icon-link": label.icon }
              })
            : _vm._e(),
          _vm._v("\n    " + _vm._s(label.label) + "\n  ")
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }